import { Map } from 'immutable';

import * as t from './actionTypes';

const initialState = Map({
  configs: [],
  cycles: [],
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case t.SET_ALL_CONFIGS:
      return state.set('configs', action.configs);
    case t.SET_ALL_CYCLES:
      return state.set('cycles', action.cycles);
    case t.SET_LOADING:
      return state.set('loading', action.loading);
    default:
      return state;
  }
}
